<script lang="ts">
    import { writable } from 'svelte/store'
    import { faAngleLeft, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
    import Popover from './popover.svelte'
    import Zinput from './z/zinput.svelte'
    import Zbutton from './z/zbutton.svelte'

    let localAlert
    let logoutAll = false

    export const globalLogout = writable(null)

    window.logout = () => {
        globalLogout.update((_) => true)
    }

    globalLogout.subscribe((value) => {
        localAlert = value
    })

    function abortLogout() {
        logoutAll = false
        globalLogout.update((_) => false)
    }

    async function goLogout() {
        await window.api.users.auth.logout(logoutAll)
        location.href = '/login'
    }
</script>

{#if localAlert}
    <Popover title="Sair da conta" width="460px" height="180px" padding="16px" on:close={abortLogout}>
        <p class="sair-pergunta">Deseja mesmo sair?</p>
        <Zinput
            skin="outline"
            type="toggle"
            label="Sair também dos outros dispositivos"
            help="Encerra a sessão em todos os aparelhos em que esta conta está aberta."
            bind:value={logoutAll}
        />
        <div class="sair-acoes">
            <Zbutton color="secondary" icon={faAngleLeft} label="Cancelar" on:click={abortLogout} />
            <div class="spacer" />
            <Zbutton color="primary" icon={faRightFromBracket} label="Sair" on:click={goLogout} />
        </div>
    </Popover>
{/if}

<style>
    .sair-pergunta {
        margin: 0px 0px 12px 0px;
        font-size: 15px;
    }

    .sair-acoes {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 16px;
    }
    .sair-acoes .spacer {
        flex: 1;
    }
</style>
